<template>
  <div class="app-order-shopping-card">
    <slot name="txtBefore"></slot>
    <slot name="txtBeforeTariff"></slot>
    <table v-if="presalesTariff">
      <thead>
      <tr>
        <th>Produkt</th>
        <th>Einmalig</th>
        <th v-html="annualTextThead"></th>
      </tr>
      </thead>
      <tbody>
      <tr class="tariff">
        <td v-html="tariffsExtra.descriptionOrdering"></td>
        <td v-html="presalesTariff.starterKit[0].formattedSinglePaymentFee"></td>
        <td v-if="presalesTariff.basicFee !== 0" v-html="presalesTariff.formattedBasicFee"></td>
        <td v-if="presalesTariff.basicFee === 0"><strong>--</strong></td>
      </tr>
      <tr>
        <td>
          <div class="extra-info">
            <div class="extra-info-title">
              <a class="extra-info-link" data-toggle="collapse" data-target="#extra-info-content" aria-expanded=false aria-controls="extra-info-content">- zusätzliche Infos </a>
            </div>
            <div class="collapse extra-info-content" id="extra-info-content" v-html="this.tariffsExtra.extraInfoOrdering">
            </div>
          </div>
        </td>
        <td></td>
        <td></td>
      </tr>
      <tr v-if="presalesTariffOption">
        <td><span class="sub-heading">Deine zusätzlichen Optionen</span></td>
        <td></td>
        <td></td>
      </tr>
      <tr class="tariff-options" v-if="presalesTariffOption">
        <td v-html="tariffOptionsExtra.descriptionOrdering"></td>
        <td v-html="tariffOptionsExtra.singlePaymentFee"></td>
        <td v-html="presalesTariffOption.formattedPrice"></td>
      </tr>
      <tr v-if="presalesTariffOption">
        <td>
          <div class="extra-info">
            <div class="extra-info-title">
              <a class="extra-info-link" data-toggle="collapse" data-target="#extra-info-content-to" aria-expanded=false aria-controls="extra-info-content">- zusätzliche Infos </a>
            </div>
            <div class="collapse extra-info-content" id="extra-info-content-to" v-html="this.tariffOptionsExtra.extraInfoOrdering">
            </div>
          </div>
        </td>
        <td></td>
        <td></td>
      </tr>
      <tr v-if="referFriend">
        <td>
          <slot name="txtFriendAdvantage"></slot>
        </td>
      </tr>
      <tr>
      <tr v-if="mnpActive">
        <td><slot name="mnpAdvantage"></slot></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>
          <div>
            <span class="sub-heading">Deine Lieferoptionen</span>
            <p class="shipping-subtext"><strong>+ Versandkosten</strong></p>
          </div>
        </td>
        <td v-html="presalesTariff.starterKit[0].formattedShippingCost"></td>
        <td v-html="tariffsExtra.annualShippingCost"></td>
      </tr>
      </tbody>
      <tfoot>
        <tr class="sum sum-heading" v-html="annualTextTfoot">
      </tr>
      <tr class="sum sum-content">
        <td><span>Gesamtsumme</span> <span>inkl. 19 % MwSt.</span></td>
        <td class="sumCosts" v-html="presalesTariff.starterKit[0].formattedCombinedCost"></td>
        <td class="sumAnnualCosts" v-html="sumAnnual"></td>
      </tr>
      </tfoot>
    </table>
    <div class="order-step">
      <b-overlay v-if="this.getStep === stepName" class="btn-next-overlay" :show="loading" spinner-small>
        <b-button @click="next" class="btn-next" type="button" variant="primary" :disabled="loading">
          <slot name="btnNext">weiter</slot>
        </b-button>
      </b-overlay>
    </div>
  </div>
</template>
<script>

import { BButton } from 'bootstrap-vue'
import { mapGetters, mapMutations } from 'vuex'
import gtmEvent from '@/mixins/gtmEvent'

export const stepName = 'shoppingCard'
export default {
  name: 'OrderShoppingCard',
  components: {
    BButton
  },
  import: { stepName },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('orderProduct', [
      'getStep'
    ]),
    ...mapGetters('orderProduct/product', [
      'getDefaultTariffId'
    ]),
    ...mapGetters('orderProduct/gtmEventData', [
      'getTariffName',
      'getTariffProductNumber',
      'getTariffPrice'
    ]),
    sumAnnual () {
      if (this.presalesTariff?.tariffId !== this.getDefaultTariffId) {
        return this.presalesTariff.formattedBasicFee
      } if (this.presalesTariffOption) {
        return this.presalesTariffOption.formattedPrice
      } else return '0 €'
    },
    annualTextThead () {
      if (this.presalesTariff?.tariffId === this.getDefaultTariffId) {
        return 'Je 30 Tage'
      }
      return 'Monatlich <br> <span>(ab 2. Monat)</span>'
    },
    annualTextTfoot () {
      if (this.presalesTariff?.tariffId === this.getDefaultTariffId) {
        return ' <td></td>\n' +
          '        <td>Einmalig</td>\n' +
          '        <td><span>Je 30 Tage</span></td>'
      }
      return ' <td></td>\n' +
        '        <td>Einmalig</td>\n' +
        '        <td>Monatlich <br> <span>(ab 2. Monat)</span></td>'
    },
    getFullTariff () {
      return this.presalesTariff
    }
  },
  updated () {
    if (this.gtmEventActive) {
      if (this.presalesTariff) {
        if (this.getStep === stepName) {
          this.pushEventAdd('eec.addToCart', this.presalesTariff.name, this.presalesTariff.starterKit[0].productNumber, this.presalesTariff.basicFee, 'fyve')
        }
      }
    }
  },
  methods: {
    ...mapMutations('orderProduct', [
      'changeStep'
    ]),
    ...mapMutations('orderProduct/product', [
      'commitSumCosts'
    ]),
    ...mapMutations('orderProduct/gtmEventData', [
      'storeTariffName',
      'storeTariffProductNumber',
      'storeTariffPrice',
      'storeTariffShippingCosts'
    ]),
    next () {
      this.loading = true
      this.changeStep({ step: this.nextStep })
      this.commitSumCosts(this.presalesTariff.starterKit[0].formattedCombinedCost)
      this.storeTariffName(this.presalesTariff.name)
      this.storeTariffProductNumber(this.presalesTariff.starterKit[0].productNumber)
      this.storeTariffPrice(this.presalesTariff.basicFee)
      this.storeTariffShippingCosts(this.presalesTariff.starterKit[0].shippingCost)
      this.pushEventCheckout('eec.checkoutStep', this.getStep, this.getTariffName, this.getTariffProductNumber, this.getTariffPrice, 'fyve')
      this.loading = false
    }
  },
  props: {
    nextStep: {
      type: String,
      default: 'options'
    },
    presalesTariff: {
      type: Object,
      default: () => {}
    },
    presalesTariffOption: {
      type: Object,
      default: () => {}
    },
    referFriend: {
      type: Boolean,
      default: false
    },
    tariffsExtra: {
      type: Object,
      default: () => {}
    },
    tariffOptionsExtra: {
      type: Object,
      default: () => {}
    },
    mnpActive: {
      default: false
    },
    gtmEventActive: {
      default: false
    }
  },
  mixins: [
    gtmEvent
  ]
}
</script>
